
import { NavLink } from 'react-router-dom'

import tf_logo from '../../assets/images/logo.svg'
import home_img from '../../assets/images/home.svg'
import users_img from './icons/users.svg'
import formazione_img from './icons/formazione.svg'
import notifiche_img from './icons/notifiche.svg'
import verifica_img from './icons/verifica.svg'
import personalizations_img from './icons/personalizations.svg'
import stats_img from './icons/stats.svg'
import super_admin_img from './icons/super_admin.svg'

import exit_img from '../../assets/images/logout.svg'
import copy_img from '../../assets/images/link-white.svg' 
import upgrade_img from '../../assets/images/upgrade.png' 

import './NavBar.css'

import { useDispatch, useSelector } from 'react-redux'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { logout } from '../../services/auth/authSlice'
import { selectUserData } from '../../features/User/userSlice'
import { BASE_URL } from '../../config/constants'
import { toast } from 'react-toastify'
import { selectTenantSettings } from '../../services/utils/appInfoSlice'

export default function NavBar(props) {

    const activeClassName = 'active_section'
    const t = useSelector(selectTranslations);
    const dispatch = useDispatch()
    const userData = useSelector(selectUserData)

    const tenantSettings = useSelector(selectTenantSettings)

    const handleCopyURL = () => {
        if(navigator.clipboard.writeText(BASE_URL))
        toast.success(t.home.copied_link)
    }

    const daysUntil = (dateString) => {
        // Converte la stringa della data in un oggetto Date
        const targetDate = new Date(dateString);
        const today = new Date();

        // Imposta l'orario di oggi a mezzanotte per un confronto più preciso (solo giorni)
        today.setHours(0, 0, 0, 0);

        // Calcola la differenza in millisecondi
        const diffTime = targetDate - today;
        
        // Converti la differenza in giorni
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        return diffDays || 0;
    }

    return(
        <nav id='mainNavBar' >
            <div>
                <img src={tf_logo} alt="thefaculty Business | Admin" style={{maxWidth:"120px"}} />
                {
                    !tenantSettings?.active_contract &&
                        <div className='mt-3 text-tf text-center p-2' style={{background:"#F2AA17", borderRadius:'16px'}}>
                            <strong className='text-white'>Versione DEMO</strong> <br />
                            {daysUntil(tenantSettings?.expiry_date)} giorni rimasti
                        </div>
                }

                <ul className='mt-5 general-step-start' >
                    <li >
                        <NavLink to={'/'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={home_img} alt=''/> {t.navbar.home}
                        </NavLink>
                    </li>
                    {userData?.permissions?.trainings && userData?.permissions?.trainings?.level > 0 ?
                    <li className='general-step-0'>
                        <NavLink to={'/folders'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={formazione_img} alt=''/> {t.navbar.training}
                        </NavLink>
                    </li> : ""}
                    {userData?.permissions?.exams && userData?.permissions?.exams?.level > 0 ?
                    <li className='general-step-1'>
                        <NavLink to={'/exams'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={verifica_img} alt=''/> {t.navbar.exams}
                        </NavLink>
                    </li> : ""}
                    {userData?.permissions?.users && userData?.permissions?.users?.level > 0 ?
                    <li className='general-step-2'>
                        <NavLink to={'/users'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={users_img} alt=''/> {t.navbar.users}
                        </NavLink>
                    </li> : ""}
                    {userData?.permissions?.notifications && userData?.permissions?.notifications?.level > 0 ?
                    <li>
                        <NavLink to={'/communications'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={notifiche_img} alt=''/> {t.navbar.notifications}
                        </NavLink>
                    </li> : ""}
                    {userData?.permissions?.personalizations && userData?.permissions?.personalizations?.level > 0 ?
                    <li className='general-step-3'>
                        <NavLink to={'/settings'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={personalizations_img} alt=''/> {t.navbar.personalizations}
                        </NavLink>
                    </li>: ""}
                    {userData?.permissions?.users && userData?.permissions?.users?.level > 0 ?
                    <li className='general-step-4'>
                        <NavLink to={'/analytics'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={stats_img} alt=''/> {t.navbar.analytics}
                        </NavLink>
                    </li>: ""}
                    {userData?.is_super_admin ?
                    <li>
                        <NavLink to={'/super_admin'} className={({ isActive }) => isActive ? activeClassName : undefined }>
                            <img src={super_admin_img} alt=''/> {t.navbar.super_admin}
                        </NavLink>
                    </li>: ""}
                </ul>
            </div>
            <div className='mb-5'>
                {
                    !tenantSettings?.active_contract &&
                        <NavLink to={'/demo/upgrade'}>
                            <button className='secondary mb-3' style={{padding:"8px"}}>
                                <img style={{verticalAlign:"middle", width:"25px"}} className='me-1' src={upgrade_img} />
                                {t.demo.activate}
                            </button>
                        </NavLink>
                }
                <a href='#' className='text-white d-block' onClick={handleCopyURL}><img style={{verticalAlign:"middle"}} src={copy_img} /> <u>{t.navbar.link}</u></a>
                <a href='#' className='text-white mt-2 d-block' onClick={()=>dispatch(logout())}><img style={{verticalAlign:"middle"}} src={exit_img} /> <u>{t.navbar.logout}</u></a>
            </div>
            
        </nav>
    )
}